import { createContext } from 'react';
import { LayoutContextValue } from '../models/layout/LayoutContext';

const LayoutContext = createContext<LayoutContextValue>({
    headerTitle: '',
    breadcrumbItems: [],
    breadcrumbPath: '',
    isMenuBarActive: false,
    menuSolicitado: null,
    setHeaderTitle: () => {},
    setBreadcrumbItems: () => {},
    toggleMenuBar: () => {},
    abrirMenu: () => {},
});

export default LayoutContext;